"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Error = function () {
    function Error() {
        _classCallCheck(this, Error);
    }

    _createClass(Error, null, [{
        key: "getErrors",

        /**
         * Compile an array of errors from the results object.
         *
         * @param {Object} results
         * @returns {Array}
         */
        value: function getErrors(results) {
            var errors = [];

            for (var result in results) {
                if (!results.hasOwnProperty(result)) {
                    continue;
                }

                if (!results[result].passed) {
                    errors.push(results[result].error);
                }
            }

            return errors;
        }

        /**
         * Get all errors from the verdict object.
         *
         * @param {Object} verdict
         * @returns {Array}
         */

    }, {
        key: "getAllErrors",
        value: function getAllErrors(verdict) {
            var errors = [];

            for (var field in verdict) {
                if (!verdict.hasOwnProperty(field)) {
                    continue;
                }

                errors = errors.concat(verdict[field].errors);
            }

            return errors;
        }
    }]);

    return Error;
}();

exports.default = Error;